/**
 * <FilterBy
 *    schooldId={schoolId} // required
 *    filters=['classroom', 'class', 'teacher', 'student'] // required
 *    onChange={(opts)=>{ console.log(opts); }} // required
 * />
 *
 *
 *
 * @parent anybody who wants to get some filtering done. (eg. Schedule calendar etc)
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';

import TextFilter from './filters/TextFilter';
import StudentFilter from './filters/StudentFilter';
import TeacherFilter from './filters/TeacherFilter';
import ClassFilter from './filters/ClassFilter';
import ClassroomFilter from './filters/ClassroomFilter';
import DateRangeFilter from './filters/DateRangeFilter';
import AttendanceClassFilter from './filters/AttendanceClassFilter';
import AttendanceStatusFilter from './filters/AttendanceStatusFilter';
import PosterRegistrationStatusFilter from './filters/PosterRegistrationStatusFilter';
import PosterFilter from './filters/posterFilter';
import './FilterBy.scss';

import omit from 'lodash/omit';

const FILTERS = {
  student: (props)=>{ return <StudentFilter {...props} /> },
  class: (props)=><ClassFilter {...props} />,
  teacher: (props)=><TeacherFilter {...props} />,
  classroom: (props)=><ClassroomFilter {...props} />,
  daterange: (props)=><DateRangeFilter {...props} />,
  attendanceClass: (props)=><AttendanceClassFilter {...props} />,
  attendanceStatus: (props)=><AttendanceStatusFilter {...props} />,
  registrationStatus: (props)=><PosterRegistrationStatusFilter {...props} />,
  poster: (props)=><PosterFilter {...props} />
}

class FilterBy extends React.Component {
  static propTypes = {
    schoolId: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this._onReset = this._onReset.bind(this);
    this._onChange = this._onChange.bind(this);

    this.state = {
      filterData: props.filterData || {},
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filterData !== this.props.filterData) {
      this.setState({
        filterData: {
          ...this.state.filterData,
          ...nextProps.filterData,
        },
      });
    }
  }

  _onChange(filterName) {
    return (value)=>{
      let {
        onChange,
      } =this.props;

      this.setState({
        filterData: {
          ...this.state.filterData,
          [filterName]: value
        },
        lastFilterChanged: filterName,
        justReset: false
      }, ()=>{
        onChange(this.state);
      });
    }
  }

  _onReset(filterName) {
    //
    // remove filter data
    //
    return ()=>{
      let {
        onChange,
      } = this.props;

      this.setState({
        filterData: {
          ...omit(this.state.filterData, filterName),
        },
        lastFilterReset: filterName,
        justReset: true,
      }, ()=>{
        onChange(this.state);
      });
    }
  }

  render() {

    const {
      filterData,
    } = this.state;

    const {
      schoolId,
      filters,
      selectMultiple,
      options = {},
    } = this.props;

    const {Id, state} = options
    return (
      <div className='filter-by'>
        {
          filters.map((name, key)=>{
            if (name.indexOf('text:') > -1) {
              let nameParts = name.split(':');
              let dataName = nameParts[1];
              return (
                <TextFilter
                  key={key}
                  Id={Id}
                  state={state}
                  schoolId={schoolId}
                  value={filterData[dataName]}
                  name={dataName}
                  options={options[name] || {}}
                  onChange={this._onChange(dataName)}
                  onReset={this._onReset(dataName)}  />
              );
            }

            if (typeof FILTERS[name] !== 'function') {
              throw new Error(`${name} is not a filter in FILTERS.`);
            }

            return FILTERS[name]({
              key,
              schoolId,
              Id,
              state,
              options: options[name] || {},
              selected: (filterData[name] || {}).items || [],
              onReset: this._onReset(name),
              onChange: this._onChange(name),
              value: filterData[name]
            });
          })
        }
      </div>
    )
  }
}

export default FilterBy;



// WEBPACK FOOTER //
// ./src/template/FilterBy/index.js